module.exports = __webpack_public_path__ + "img/marcelasroundtrans.04b5b51e.png";